import { filesToDocuments } from '@equifinance/shared';
import { ChecklistDocumentPayload } from '../../../contexts/checklist';

export const filesToChecklistDocuments = async (files: File[]): Promise<ChecklistDocumentPayload[]> => {
  const documents = await filesToDocuments(files);

  return documents.map(({ name, data, extension }) => ({
    fileName: name,
    documentData: data,
    documentType: extension,
  }));
};
